import React, { useState } from 'react';
import ImageModal from '../modals/ImageModal';
import { IMAGES } from '../../constants/artForms';

const OtherArts = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const artForms = [
        {
            title: "Kathak",
            image: IMAGES.KATHAK,
            description: "Discover the rhythmic footwork and graceful movements of Kathak through our network of dedicated performers across America."
        },
        {
            title: "Odissi",
            image: IMAGES.ODISSI,
            description: "Experience the lyrical beauty of Odissi dance as performed by our talented American artists, preserving this ancient tradition."
        },
        {
            title: "Mohiniyattam",
            image: IMAGES.MOHINIYATTAM,
            description: "Witness the enchanting grace of Mohiniyattam through performances by our accomplished dancers throughout America."
        },
        {
            title: "Hindustani Classical Music",
            image: IMAGES.HINDUSTANI_MUSIC,
            description: "Immerse yourself in the rich melodies of Hindustani Classical Music with our community of dedicated musicians across America."
        },
        {
            title: "Indian Sculpture & Architecture",
            image: IMAGES.INDIAN_SCULPTURE,
            description: "Explore the intricate artistry of Indian sculpture and architecture through exhibitions and installations across America."
        },
        {
            title: "Indian Classical Painting",
            image: IMAGES.INDIAN_PAINTING,
            description: "Discover the vibrant traditions of Indian classical painting through galleries and workshops throughout America."
        }
    ];

    return (
        <section id="other-arts" className="py-20 bg-black">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 section-heading">
                    Discover More Art Forms
                </h2>
                <p className="text-gray-300 text-lg mb-8">
                    Explore the rich diversity of Indian classical arts flourishing across America through our vibrant community of artists and cultural ambassadors.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {artForms.map((art, index) => (
                        <div 
                            key={index}
                            className="bg-gray-900 rounded-xl shadow-lg p-6 flex flex-col items-center text-center transform hover:scale-105 transition duration-300 ease-in-out cursor-pointer"
                            role="button"
                            tabIndex={0}
                            aria-label={`View ${art.title}`}
                        >
                            <img 
                                src={art.image} 
                                alt={art.title}
                                className="rounded-lg mb-4 w-full h-64 object-contain cursor-pointer"
                                onClick={() => {
                                    setSelectedImage(art.image);
                                    setSelectedIndex(index);
                                }}
                            />
                            <h3 className="text-2xl font-semibold text-white mb-3">
                                {art.title}
                            </h3>
                            <p className="text-gray-300">
                                {art.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {selectedImage && (
                <ImageModal
                    image={selectedImage}
                    onClose={() => setSelectedImage(null)}
                    onNext={() => {
                        if (selectedIndex < artForms.length - 1) {
                            setSelectedImage(artForms[selectedIndex + 1].image);
                            setSelectedIndex(selectedIndex + 1);
                        }
                    }}
                    onPrev={() => {
                        if (selectedIndex > 0) {
                            setSelectedImage(artForms[selectedIndex - 1].image);
                            setSelectedIndex(selectedIndex - 1);
                        }
                    }}
                    hasNext={selectedIndex < artForms.length - 1}
                    hasPrev={selectedIndex > 0}
                    title={artForms[selectedIndex].title}
                    description={artForms[selectedIndex].description}
                />
            )}
        </section>
    );
};

export default OtherArts;
